const { refreshToken } = require('../firebase')
const getToken = () => (typeof window !== 'undefined' ? window.localStorage.getItem('token') : null)

const makeRequest = async (method = 'POST', endpoint, data = {}, token, responseType = 'json') => {
  const configs = {}
  if (method === 'POST') {
    configs.body = JSON.stringify(data)
  }
  try {
    await refreshToken()
  } catch (error) {
    console.warn('cant update firebase token', error)
  }
  // eslint-disable-next-line no-undef
  const response = await fetch(`/api/script/writers-room/${endpoint}`, {
    method: method,
    ...configs,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
  if (!response.ok) {
    const error = new Error(response.statusText)
    error.status = response.status
    throw error
  }
  return response[responseType]()
}

export const getScriptsData = async (data = {}, token) => {
  token = token || (await getToken())
  // skip store data if there is no token provided
  if (!token) {
    throw Error('Token is required')
  }
  return makeRequest('GET', 'dummy_get', data, token)
}
